export const vrtrustSetupTips = [
  {
    title: 'Have your PMS login details ready.',
    description:
      'Connecting your property management system is your next step. Find the guide for your PMS before you begin.',
    linkLabel: 'View connection guides',
    href: 'https://support.vrplatform.app/en/collections/11651345-vrtrust-connections',
  },
  {
    title: 'A clear path through your first steps.',
    description:
      'The VRPilot onboarding guide walks your team through all setup tasks in the right order, so nothing gets missed.',
  },
  {
    title: 'Choose your accounting start date.',
    description:
      'Decide when you want to start accounting in VRTrust. Our guide explains go-live dates and opening balances.',
    linkLabel: 'Learn about going live',
    href: 'https://support.vrplatform.app/en/articles/13393764-course-5-go-live-opening-balances-vrtrust',
  },
  {
    title: 'Bring your AI assistant into VRTrust.',
    description:
      'Connect Claude and other AI tools through our MCP server, so they can search your data and make changes with your confirmation.',
    linkLabel: 'Read the MCP connection guide',
    href: 'https://docs.vrplatform.app/mcp',
  },
  {
    title: 'Find an accountant who speaks STR.',
    description:
      'Browse our vetted network of accounting professionals who specialize in serving short-term rental property management companies.',
    linkLabel: 'Explore the accounting partner marketplace',
    href: 'https://www.vrplatform.app/accounting-partners-marketplace',
  },
];

export const partnerSetupTips = [
  {
    title: 'Your clients, together in one dashboard.',
    description:
      'Your partner dashboard brings client teams, users, and connection statuses into one place.',
    linkLabel: 'Explore your partner dashboard',
    href: 'https://support.vrplatform.app/en/articles/9270021-accounting-partner-dashboard-overview',
  },
  {
    title: 'Move easily between client teams.',
    description:
      'Use the team menu to switch between clients. Recently accessed teams stay close at hand.',
    linkLabel: 'Learn how to switch teams',
    href: 'https://support.vrplatform.app/en/articles/14713236-how-do-i-switch-between-teams-in-vrtrust-and-vrplatform',
  },
  {
    title: 'Bring your AI assistant into VRTrust.',
    description:
      'Connect Claude and other AI tools through our MCP server, so they can search your data and make changes with your confirmation.',
    linkLabel: 'Read the MCP connection guide',
    href: 'https://docs.vrplatform.app/mcp',
  },
];
